import React from 'react'
import { Text } from 'blaze-ui/Text/Text'
import { HighDetailedSocial } from 'blaze-ui/icons/40'
import { HighDetailedForYou } from 'blaze-ui/icons/40/HighDetailedForYou'
import HighDetailedImproveQuality from 'blaze-ui/icons/40/HighDetailedImproveQuality'
import { ProgressCircle } from 'components/FirstTimeExperienceModal/steps/BrandPlanCurrentVolumeV2/ProgressCircle'
import Styles from './TacticIntegrationTopBar.module.scss'

interface TacticIntegrationTopBarProps {
  numConnectedAccounts: number
  numPossibleConnections: number
}

export const TacticIntegrationTopBar: React.FC<TacticIntegrationTopBarProps> = ({
  numConnectedAccounts,
  numPossibleConnections,
}) => {
  return (
    <div className={Styles.topBar}>
      <div className={Styles.infoItem}>
        <HighDetailedForYou size={30} />
        <Text>Learns from every post to grow your audience</Text>
      </div>
      <div className={Styles.infoItem}>
        <HighDetailedSocial size={30} />
        <Text>Handles posting so you stay consistent</Text>
      </div>
      <div className={Styles.infoItem}>
        <HighDetailedImproveQuality size={30} />
        <Text>Delivers AI insights to grow your reach</Text>
      </div>
      <div className={Styles.progressCircleContainer}>
        <ProgressCircle amount={numConnectedAccounts} totalAmount={numPossibleConnections} />
      </div>
    </div>
  )
}
